<section class="seller-container" *ngIf="!showErrorFormsService">
  <section class="ids-mv-6 ids-p-3">
    <section class="breadcrumb-box">
      <button idsActionButton (click)="backStep()">
        <ids-icon variant="primary" #backButton id="backButton">seta_esquerda</ids-icon>
        voltar
      </button>
      <p class="ids-color-text-highlight">etapa {{ currentStep }} / {{ totalSteps }}</p>
    </section>

    <section class="ids-pt-4">
      <ids-progress-bar weight="heavy" [fill]="percent"></ids-progress-bar>
    </section>

    <app-seller-step-one-pf
      *ngIf="currentStep === 1 && this.dataPersonal.documentNumber"
      (formsComplete)="receiverFormsStatus($event)"
      (dataForms)="receiverDataForms($event)"
      [dataPersonal]="dataPersonal"
    ></app-seller-step-one-pf>


    <app-seller-step-two-pf
      *ngIf="currentStep === 2 && hasParticipant()"
      (formsComplete)="receiverFormsStatus($event)"
      [dataPersonal]="dataPersonal"
    ></app-seller-step-two-pf>
    <app-seller-step-three-pf
      *ngIf="(currentStep === 3 && hasParticipant()) || (currentStep === 2 && !hasParticipant())"
      (formsComplete)="receiverFormsStatus($event)"
      [dataPersonal]="dataPersonal"
    ></app-seller-step-three-pf>
    <app-seller-resume-pf
      *ngIf="currentStep === 4 || (currentStep === 3 && !hasParticipant())"
      (formsComplete)="receiverFormsStatus($event)"
      [dataPersonal]="dataPersonal"
    ></app-seller-resume-pf>

    <section class="ids-row ids-pt-7">
      <section class="ids-col-4">
        <button
          *ngIf="currentStep < totalSteps"
          (click)="goToNextStep()"
          [disabled]="buttonDisabled"
          full
          idsMainButton
        >
          continuar
        </button>

        <button
          idsMainButton
          full
          *ngIf="(currentStep === 4 || (currentStep === 3 && !hasParticipant()))"
          [loading]="loadingSaveForm"
          [disabled]="buttonDisabled"
          (click)="submitFormsPf()"
        >
          salvar formulário
        </button>
      </section>
    </section>
  </section>
</section>

<section class="seller-container">
  <section class="ids-mv-6 ids-p-3">
    <app-error-screen
      *ngIf="showErrorFormsService"
      (onClickTryAgain)="reciverTryAgain()"
    ></app-error-screen>
  </section>
</section>

<app-modal-back-button [(openModal)]="showModalExit" (backFormEvent)="navigateFormList()"></app-modal-back-button>
